import { useProfile } from "../context/ProfileContext";
import { CalendarDays, MapPin } from "lucide-react";

export default function UpcomingTournaments() {
  const PROFILE = useProfile();
  return (
    <section
      id="upcoming"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-white/10"
      data-testid="upcoming-section"
    >
      <div className="max-w-screen-2xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold mb-4">
              Schedule — Catch Her Live
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase font-bold tracking-tight text-white leading-none">
              <CalendarDays
                size={42}
                className="inline-block mb-2 mr-3 text-[#E60000]"
                strokeWidth={1.5}
              />
              Upcoming Tournaments
            </h2>
          </div>
          <p className="max-w-md text-[#8A8A8A] text-base leading-relaxed">
            Where to scout Faith next. All events with A5 17-2 Angel — full schedule available on request.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6" data-testid="upcoming-grid">
          {PROFILE.upcoming.map((t, i) => (
            <article
              key={t.name}
              className="border border-white/10 p-8 lg:p-10 hover:bg-[#111111] hover:border-[#E60000] transition-all flex flex-col gap-6 min-h-[280px]"
              data-testid={`upcoming-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-[0.3em] uppercase text-[#E60000] font-bold">
                  Event 0{i + 1}
                </span>
                <span className="font-display text-xl font-bold text-[#8A8A8A] tracking-tight">
                  {t.start.split(",")[0].split(" ").slice(-1)[0]}
                </span>
              </div>

              <h3 className="font-display text-2xl sm:text-3xl uppercase font-bold tracking-tight text-white leading-tight">
                {t.name}
              </h3>

              <div className="flex-1 space-y-3">
                <div className="flex items-start gap-3">
                  <CalendarDays size={14} className="text-[#E60000] mt-0.5 shrink-0" strokeWidth={2.5} />
                  <div className="text-sm text-[#cfcfcf] leading-snug">
                    <div>{t.start}</div>
                    <div className="text-[#8A8A8A]">— {t.end}</div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <MapPin size={14} className="text-[#E60000] mt-0.5 shrink-0" strokeWidth={2.5} />
                  <div className="text-sm text-[#cfcfcf] leading-snug">
                    <div>{t.venue}</div>
                    <div className="text-[#8A8A8A]">{t.city}</div>
                  </div>
                </div>
              </div>

              <div className="pt-4 border-t border-white/10 text-[10px] tracking-[0.25em] uppercase text-[#8A8A8A]">
                With A5 17-2 Angel · Jersey #31
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
